export default __webpack_public_path__ + "static/media/emptyposition.d673fdfb.svg";